<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title">{{'Class' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}} *</label>
      <input class="form-control" [(ngModel)]="entity.name" placeholder="e.g. 5A, 3B" />
    </div>

    <div class="form-group">
      <label>{{'Grade' | translate}}</label>
      <input type="number" class="form-control" [(ngModel)]="entity.grade" min="1" />
    </div>

    <div class="form-group">
      <label>{{'Education level' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.educationLevelId">
        <option [ngValue]="null">{{'Select education level' | translate}}</option>
        <option *ngFor="let level of educationLevels" [ngValue]="level.id">
          {{level.name}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input id="internshipsAllowed" class="custom-control-input" type="checkbox" [(ngModel)]="entity.internshipsAllowed" />
        <label for="internshipsAllowed" class="custom-control-label">{{'Internships allowed' | translate}}</label>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
